export const PROFILE_INFO_FULL = '/api/user/v1/full';
export const PROFILE_INFO = '/api/user/v1';
export const PROFILE_AVATAR = '/api/user/v1/avatar-update';
export const DELETE_PROFILE_AVATAR = '/api/user/v1/avatar-delete';
export const UPDATE_PROFILE_INFO = '/api/user/v1/profile-update';
export const UPDATE_PROFILE_JOB_TITLE = '/api/user/v1/job-title-update';
export const UPDATE_ORGANIZATION = '/api/user/v1/organization';
